<template>
  <div class="header__container header__container--no-navigation">
    <div class="nav__logo">
      <div class="unlink-logo">
        <ImgLazy
          :image-url="noNavigationLogoImage"
          alt-text="no-navigation-logo"
          aspect-ratio="80 / 24"
          :width="80"
          :height="24"
        />
      </div>
    </div>
  </div>
</template>
<script>
import ImgLazy from '../../atoms/images/ImgLazy.vue'
export default {
  components: {
    ImgLazy
  },
  props: {
    noNavigationLogoImage: {
      type: String,
      required: true
    }
  }
}
</script>
